import React, { useState } from "react";
import "./loginpage.css";
import { useNavigate } from "react-router-dom";
import logo from "../assets/icons/CDR-Logo.png";
import { useAuthStore } from "../Services/authStore";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const login = useAuthStore((state) => state.login);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (email !== email.trim()) {
      setError("Email cannot start or end with a space.");
      return;
    }

    if (!email || !password) {
      setError("Please fill in all fields.");
      return;
    }

    setLoading(true);

    try {
      const result = await login(email, password);

      if (!result.success) {
        setError(result.message || "Login failed");
        return;
      }

      navigate("/dashboard");
    } catch (err) {
      setError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  return (
    <main className="login-page">
      <div className="login-card">
        {/* ── LEFT: Brand panel ── */}
        <aside className="brand-panel">
          <div>
            <div className="brand-logo" aria-hidden="true">
              <img src={logo} alt="Brand Logo" className="brand-logo__img" />
            </div>

            {/* Headline */}
            <h1 className="brand-headline">
              The Art
              <br />
              of Fine
              <br />
              Dining.
            </h1>

            {/* Tagline */}
            <p className="brand-tagline">
              A brotherhood of gastronomes across 80+ countries, united by
              excellence at the table since 1248.
            </p>

            {/* Divider */}
            <div className="brand-divider" />

            {/* Quote */}
            <blockquote className="brand-quote">
              <p className="brand-quote__body">
                "Every meal is a ceremony, every table a gathering of souls."
              </p>
              <cite className="brand-quote__attr">— Chaîne des Rôtisseurs</cite>
            </blockquote>
          </div>

          {/* Stats */}
          <div className="brand-stats" aria-label="Membership statistics">
            <div className="brand-stat">
              <span className="brand-stat__label">Active members</span>
              <span className="brand-stat__value">25,000+</span>
            </div>
            <div className="brand-stat">
              <span className="brand-stat__label">Bailliages worldwide</span>
              <span className="brand-stat__value">700+</span>
            </div>
            <div className="brand-stat">
              <span className="brand-stat__label">Countries represented</span>
              <span className="brand-stat__value">80+</span>
            </div>
          </div>
        </aside>
        <section className="form-panel">
          <div className="mobile-logo">
            <img src={logo} alt="Brand Logo" className="mobile-logo-img" />
          </div>

          <p className="form-eyebrow">Club OS · Member Portal</p>

          <h2 className="form-title">Sign in</h2>

          <p className="form-subtitle">Access your membership dashboard</p>

          <form onSubmit={handleSubmit} noValidate>
            {/* Email */}
            <div className="field">
              <div className="field__header">
                <label className="field__label" htmlFor="email">
                  Email address
                </label>
              </div>
              <div className="field__input-row">
                <i className="ti ti-mail field__icon" aria-hidden="true" />
                <input
                  id="email"
                  className="field__input"
                  type="email"
                  placeholder="bailli@cdr.org"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            {/* Password */}
            <div className="field">
              <div className="field__header">
                <label className="field__label" htmlFor="password">
                  Password
                </label>
                <button
                  type="button"
                  className="field__link"
                  onClick={() => alert("Password reset flow")}
                >
                  Forgot?
                </button>
              </div>
              <div className="field__input-row field__input-row--focused">
                <i className="ti ti-lock field__icon" aria-hidden="true" />
                <input
                  id="password"
                  className="field__input"
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••••"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="field__eye"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            {/* Error message */}
            {error && (
              <p
                role="alert"
                style={{
                  fontSize: "12px",
                  color: "#E07070",
                  marginBottom: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <i className="ti ti-alert-circle" aria-hidden="true" />
                {error}
              </p>
            )}

            {/* Primary CTA */}
            <button
              type="submit"
              className="btn-primary"
              disabled={loading}
              aria-busy={loading}
            >
              {loading ? (
                <>
                  <i className="ti ti-loader" aria-hidden="true" />
                  Signing in…
                </>
              ) : (
                <>
                  Sign in to Club OS
                  <i className="ti ti-arrow-right" aria-hidden="true" />
                </>
              )}
            </button>
          </form>
        </section>
      </div>
    </main>
  );
}
